<template>
    <div
        class="flex gap-5 flex-col popular-items overflow-auto py-4"
        style="scrollbar-width: thin; scrollbar-gutter: stable"
    >
        <h2
            class="font-heading pl-4 md:pl-0 sticky left-0 text-2xl font-bold text-category-heading"
        >
            {{ $t('popularProducts.title') }}
        </h2>
        <ul v-if="products.length" class="flex gap-5 w-full px-4 md:px-0">
            <popular-item
                v-for="(product, index) in products"
                :key="`product-${index}`"
                :item="product"
                :is-available="product.isAvailable"
                :large-images="product.largeImages"
                :image-size="product.imageSize"
                :quick-add="product.quickAdd"
                :source="'popular_items_cat'"
                @click.native="$emit('show-modal', product)"
            />
        </ul>
    </div>
</template>

<script>
import PopularItem from '@/components/PopularItem.vue';

export default {
    name: 'PopularProducts',
    components: {
        PopularItem
    },
    props: {
        products: {
            type: Array,
            required: true
        }
    }
};
</script>
